import request from '/@/utils/request';

/**
 * 登录api接口集合
 * @method signIn 用户登录
 * @method signOut 用户退出登录
 */
export function useLoginApi() {
    return {
        signIn: (params: object) => {
            return request({
                url: '/api/AdminAccount/login',
                method: 'post',
                data: params,
                skipErrorHandle: true,
            });
        },

        GetUserInfo: (params: object) => {
            return request({
                url: '/api/AdminAccount/user_info',
                method: 'get',
                params,
            });
        },

        getLoginCode: (params: object) => {
            return request({
                url: '/api/AdminAccount/send_admin_auth_code',
                method: 'get',
                params,
            });
        },
    };
}